<template>
  <div v-if="allowEdit">
    <v-btn
      class="bottom-bar-actions-dropdown-button"
      v-show="actions && actions.length > 0 && !formIsActive"
      fab
      text
      :class="{
        'change-active-background':
          bottomBarIsVisible && enteredFromConfiguration,
        'bottom-bar-actions-dropdown-button-active': bottomBarIsVisible,
        'bottom-bar-actions-dropdown-button-active-configuration':
          $route.path.split('/')[3] === 'configuration',
        'f2g-light-gray-2': bottomBarIsVisible,
      }"
      :style="setButtonBackgroundColor()"
      @click="changeVisibility"
    >
      <F2gIcon
        v-if="bottomBarIsVisible"
        :class="enteredFromConfiguration ? 'close-arrow' : ''"
        :key="2"
        :height="40"
        stroke="gray"
        :stroke-width="3"
        value="arrow-right"
        :style="marginCloseArrow ? `margin-left: ${marginCloseArrow}` : ''"
        :width="40"
      ></F2gIcon>
      <F2gIcon
        v-else
        :fill="ownerColors.ownerOnPrimaryColor"
        file="icons_solid.svg"
        :key="1"
        solid
        value="edit"
        :width="22"
      ></F2gIcon>
    </v-btn>
    <div
      class="bottom-bar-actions"
      :class="{ 'bottom-bar-actions-visible': bottomBarIsVisible }"
      v-show="actions && actions.length > 0"
    >
      <div
        class="bottom-bar-actions-item pa-1 text-center text--md"
        :class="action.disabled ? 'bottom-bar-actions-item--not-allowed' : ''"
        :style="action.itemWidth ? 'width:' + action.itemWidth : ''"
        v-for="(action, index) in actions"
        :key="index"
        :disabled="action.disabled ? action.disabled : false"
        @click="!action.disabled ? action.callback() : ''"
      >
        <v-layout
          column
          justify-center
          align-center
          style="height: 100%"
          v-if="!action.disabled"
        >
          <F2gIcon
            :value="action.icon"
            :stroke="
              action.color ? action.color : $CONSTANTS.COLOUR.BLACK_1_F2G
            "
            :strokeWidth="action.strokeWidth ? action.strokeWidth : 2"
            :key="index"
          />
          <span
            :style="
              'color:' +
              (action.colorText
                ? action.colorText
                : $CONSTANTS.COLOUR.BLACK_1_F2G)
            "
            >{{ action.tooltipText }}</span
          >
        </v-layout>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <v-layout
              column
              justify-center
              align-center
              v-on="on"
              style="height: 100%"
            >
              <F2gIcon
                :value="action.icon"
                :stroke="
                  action.color ? action.color : $CONSTANTS.COLOUR.BLACK_1_F2G
                "
                :strokeWidth="action.strokeWidth ? action.strokeWidth : 2"
              />
              <span
                :style="
                  'color:' +
                  (action.colorText
                    ? action.colorText
                    : $CONSTANTS.COLOUR.BLACK_1_F2G)
                "
                >{{ action.tooltipText }}</span
              >
            </v-layout>
          </template>
          <span>{{
            $t(
              action.tooltip
                ? action.tooltip
                : "errors.actionNotAllowedVehicleInUse"
            )
          }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/flit2go-web-core/util/event-bus.js";
import menuStructureFile from "@/base/menuStructure/menuStructure.js";

export default {
  name: "BottomBarActions",
  props: {
    isConfiguration: Boolean,
  },
  data: () => ({
    spriteUrl: require("@/flit2go-web-core/assets/toolbar-svg-orion.svg"),
    actions: [],
    formIsActive: false,
    bottomBarIsVisible: false,
    configuration: false,
    bottomBarOpened: false,
    allowEdit: true,
    menuStructureFile,
    enteredFromConfiguration: false,
    marginCloseArrow: null,
  }),
  computed: {
    ...mapGetters({
      userProfile: "auth/getUserProfile",
      ownerColors: "auth/getOwnerColors",
    }),
  },
  created() {
    EventBus.$on("actions", (data) => {
      this.allowEdit = this.menuStructureFile.hasWritePermission(
        this.$route.meta.code
      );
      if (data === null) {
        this.actions = [];
        this.formIsActive = false;
        this.bottomBarIsVisible = false;
        this.marginCloseArrow = null;
      } else {
        this.actions = data.buttons;
        this.formIsActive = data.formIsActive;
        this.bottomBarIsVisible = this.formIsActive;
        this.marginCloseArrow = data.marginCloseArrow
          ? data.marginCloseArrow
          : null;
        this.$emit("changeVisibility", this.bottomBarIsVisible);
      }
    });
    EventBus.$on("bottombarInConfiguration", (bool) => {
      this.enteredFromConfiguration = bool;
    });
  },
  methods: {
    setButtonBackgroundColor() {
      const colour = this.bottomBarIsVisible
        ? "white"
        : this.ownerColors.ownerPrimaryColor;
      return `background-color: ${colour}`;
    },
    changeVisibility() {
      this.bottomBarIsVisible = !this.bottomBarIsVisible;
      this.$emit("changeVisibility", this.bottomBarIsVisible);
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-bar-actions-dropdown-button {
  border-radius: 50% 0% 0% 50%;
  bottom: 11px;
  height: 50px;
  margin: 0px;
  right: 0%;
  position: fixed;
  transition: all 0.5s ease-in-out;
  width: 50px;
  z-index: 51;
}
.close-arrow {
  margin-left: 500px;
}
.bottom-bar-actions-dropdown-button-active {
  background-color: transparent;
  border-radius: 50%;
  height: 50px;
  right: calc(100% - 146px);
  transition: all 0.5s ease-in-out;
  width: 50px;
  &--configuration {
    right: calc(100% - 330px);
  }
  &--configuration-contracted {
    right: calc(100% - 146px);
  }
}
.bottom-bar-actions-dropdown-button-active:hover {
  background-color: rgb(226, 226, 226);
}
.bottom-bar-actions-dropdown-button-active::before {
  background-color: transparent;
}
.change-active-background {
  background-color: #ffffff;
}
.change-active-background:hover {
  background-color: #ffffff;
}
.bottom-bar-actions {
  background-color: $light-gray;
  box-shadow: 20px 0px 20px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  justify-content: flex-end;
  max-height: 140px;
  min-height: 70px;
  overflow-y: auto;
  transform: translateX(100%);
  transition: transform 0.5s ease-in-out;
  width: 100%;
  //z-index: 50;

  &-item {
    cursor: pointer;
    font-weight: 500;
    height: 70px;
    min-width: 100px;
    text-transform: uppercase;
    word-wrap: break-word;

    &--not-allowed {
      cursor: not-allowed;
    }
  }

  &-item:hover {
    background-color: $f2g-light-gray-2;
  }
}

.bottom-bar-actions-visible {
  transform: translate(0%);
  transition: transform 0.5s ease-in-out;
}
</style>
